var React = require('react');

function IconTopO (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M948.351 51.14v86.573H82.619V51.14h865.732zM515.485 303.616L731.287 513.01H608.144l.278 88.277.718 227.585H422.677V513.009H299.683l215.802-209.393m0-122.616L82.619 601.009h252.058v315.862h362.742l-.996-315.862h251.928L515.485 181z"}));
}

IconTopO.displayName = "IconTopO";

IconTopO.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconTopO;

IconTopO.default = IconTopO;
